<template>
  <div>
    <el-dialog
      title="叠加包"
      :visible.sync="visible"
      :width="`${renewParams.type == 3 ? '1200px':'400px'}`"
      class="price_box"
      @close="handleClose"
      >
        <div>
          <p v-if="renewParams.type == 3">
            SIM卡号：
            <el-input 
              v-model="renewParams.sim" 
              @blur="changeRenew()"
              style="width:600px;"
              size="small"
              type="text"
              placeholder="多个卡号请用,隔开或卡段"
            />
            <el-upload
              class="upload-demo"
              style="width:100px;float:right"
              action=""
              multiple
              :http-request="({ file }) => (renewParams.excelFile = file)"
              :show-file-list="false"
              :on-change="handlerExport"
            >
              <el-button type="primary" size="small">上传文件</el-button>
            </el-upload>
          </p>
          <div style="margin-top:10px">
            <span v-if="passwordFlag">
              密码：
              <el-input 
                type="password"
                size="small"
                v-model="renewParams.secondPassword"
                style="width:200px;"
              />
            </span>
            <span class="price_row_span">
              提示：叠加包操作后不能回退与修改，请谨慎操作
              <span 
                class="download" 
                @click="handleDownload"
              >
                模板下载
              </span>
            </span>
          </div>
          <div class="list" :class="{'w__100':renewParams.type !== 3}">
            <div v-if="useShowHide('new')">
              <span>
                套餐类型：
                <el-select 
                  v-model="renewParams.simType" 
                  placeholder="请选择套餐"
                  @change="handleConsume($event,1)"
                >
                  <el-option
                    v-for="item in simType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <ul class="list__ul">
                <li v-for="(item,index) in renewParams.new" :key="index"><span>{{item.simCard}}</span><span>{{ item.cardSupplier }}</span></li>
              </ul>
            </div>
            <div v-if="useShowHide('old')">
              <span>
                套餐类型：
                <el-select 
                  v-model="renewParams.oldSimType" 
                  placeholder="请选择套餐"
                  @change="handleConsume($event,2)"
                >
                  <el-option
                    v-for="item in oldSimType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <ul class="list__ul">
                <li v-for="(item,index) in renewParams.old" :key="index"><span>{{item.simCard}}</span><span>{{ item.cardSupplier }}</span></li>
              </ul>
            </div>
            <div v-if="useShowHide('connect')">
              <span>
                联通
                套餐类型：
                <el-select 
                  v-model="renewParams.connectSimType" 
                  placeholder="请选择套餐"
                  @change="handleConsume($event,3)"
                >
                  <el-option
                    v-for="item in connectSimType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <ul class="list__ul">
                <li v-for="(item,index) in renewParams.connect" :key="index">{{item.simCard}}</li>
              </ul>
            </div>
          </div>
          <!-- <div>
            <p class="box_p">
              <el-checkbox 
                v-model="renewParams.checked"
              >
                此操作消耗虚拟币“
                <span>{{renewParams.newCorn + renewParams.oldCorn}}</span>”个
              </el-checkbox>
            </p>
          </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button  size="small" @click="visible=false">取 消</el-button>
          <el-button type="primary" size="small" @click="handleOrder()">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 查看sim卡号 start -->
    <el-dialog
      title="不能操作叠加包SIM卡号"
      :visible.sync="outSimShow"
      :close-on-click-modal="false"
      width="600px"
    >
    <div style="word-wrap:break-word;height:300px;overflow-y:auto;padding:0 10px;text-align:center">
      {{outSimShowSimSegment}}
    </div>
    </el-dialog>
    <!-- 查看sim卡号 end -->
  </div>
</template>
<script>
export default {
  data(){
    return {
      outSimShow:false,
      outSimShowSimSegment:'',
      visible:false,
      renewParams:{
        activeType:0,
        simType:'',
        oldSimType:'',
        connectSimType:'',
        remark:'',
        type:0,
        sim:'',
        checked:false,
        new:[],
        old:[],
        connect:[],
        newCorn:0,
        oldCorn:0,
        connectCorn:0,
        secondPassword:'',
        excelFile:null
      },
      simType: [],
      oldSimType: [],
      connectSimType: [],
    }
  },
  created(){
    this.getSimType();
  },
  computed:{
    //获取支付密码状态
    passwordFlag(){
      return this.$store.state.passwordFlag;
    }
  },
  methods: {
    useCardSupplier(type){
      return {
        1:'北京移动',
        2:'江门移动',
        3:'重庆卡',
        4:'江西卡',
        5:'深圳卡',
        6:'谷米卡',
        7:'北京移动(新)',
        8:'北京移动(新)',
        9:'北京移动(新)',
        10:'北京移动语音卡',
        11:'深圳移动',
        12:'联通',
        13:'北京移动4G卡',
        14:'惠州联通',
        15:'陕西移动',
        16:'云杉卡',
        17:'齐犇卡',
        18:'北京单4G卡',
      }[type];
    },
    // 判断显示
    useShowHide(name){
      return this.renewParams.type !== 3 ? this.renewParams[name].length : true;
    },
     //下载模板
    handleDownload(){
      window.open('./renew.xlsx')
    },
    //导入文件
    async handlerExport(row){
      let formData = new FormData();
      formData.append('file',row.raw);
      const { data } = await this.$API.parserExcelToSegment(formData);
      if(data.code == 0){
        this.renewParams.type = 3;
        this.renewParams.sim = data.data;
        this.changeRenew();
      }
      this.$message({
        type:data.code == 0?'success':'warning',
        message:data.code == 0?'上传成功':data.msg
      })
    },
    //获取叠加套餐
    async getSimType(){
      const { data } = await this.$API.getPackageKind();
      data.data.length && (
        data.data.map(item => {
          if (item.type == 1)
          {
            let str = (item.simType > 100 ? parseInt(item.simType) / 1024 + 'G' : item.simType + 'M');
            this.simType.push({
              value: str,
              label: str,
              price: item.price,
              id: item.id
            })
          } else if (item.type == 3)
          {
            this.connectSimType.push({
              value: item.name,
              label: item.name,
              price: item.price,
              id: item.id
            })
          } else
          {
            let str = (item.simType > 100 ? parseInt(item.simType) / 1024 + 'G' : item.simType + 'M');
            this.oldSimType.push({
              value: str,
              label: str,
              price: item.price,
              id: item.id
            })
          }
        })
      );
    },
    // 获取特殊客户叠加包价格
    async getCornNum () {
      try{
        const params = {
          userId:this.$store.state.LOGINUSER.id,
          secondPassword:this.renewParams.secondPassword,
          dto:[...this.renewParams.new , ...this.renewParams.old , ...this.renewParams.connect]
        }
        const cornNumRes = await this.$API.getSpecialCustomOverPrice(params);
        if (cornNumRes.data.code !== 0) throw { msg: cornNumRes.data.msg };
        ;
        const str = `<p class="box_p">此操作消耗虚拟币“<span style="color:#d61c1c">${cornNumRes.data.data.totalPrice}</span> ”个</p>`;
        this.$alert(str, '提示', {
          dangerouslyUseHTMLString: true
        }).then(async action => {
          let params = {
            userId:this.$store.state.LOGINUSER.id,
            secondPassword:this.renewParams.secondPassword,
            dto:[...this.renewParams.new , ...this.renewParams.old , ...this.renewParams.connect]
          }
          const { data } = await this.$API.exameFlowPackage(params);
          if(data.code == 0){
            this.$message({
              type:'success',
              message:'叠加套餐成功'
            });
            this.visible = false;
            this.$emit('searchSimList');
          }else{
            this.$message({
              type:'warning',
              message:data.msg
            });
          }
        }).catch(()=>{

        })
      } catch ({ msg }){
        this.$message({
          type: 'warning',
          message:msg
        })
      }
    },
    //提交
    async handleOrder () {
      try{
        if(this.renewParams.new.length && !this.renewParams.new[0].packageType)throw{msg:'新卡未选择叠加套餐'};
        if(this.renewParams.old.length && !this.renewParams.old[0].packageType)throw{msg:'旧卡未选择叠加套餐'};
        if (this.renewParams.connect.length && !this.renewParams.connect[0].packageType) throw { msg: '旧卡未选择叠加套餐' };
        if (this.$store.state.LOGINUSER.userCode === 'FC68'){
          return this.getCornNum();
        }
        // if(!this.renewParams.checked)throw{msg:'请勾选确定消耗虚拟币数'};
        const str = `<p class="box_p">
            此操作消耗虚拟币“
            <span style="color:#d61c1c">
              ${this.renewParams.newCorn + this.renewParams.oldCorn + this.renewParams.connectCorn}
            </span>
            ”个
        </p>`;
        this.$alert(str, '提示', {
          dangerouslyUseHTMLString: true
        }).then(async action => {
          let params = {
            userId:this.$store.state.LOGINUSER.id,
            secondPassword:this.renewParams.secondPassword,
            dto:[...this.renewParams.new , ...this.renewParams.old , ...this.renewParams.connect]
          }
          const { data } = await this.$API.exameFlowPackage(params);
          console.log(data);
          if(data.code == 0){
            this.$message({
              type:'success',
              message:'叠加套餐成功'
            });
            this.visible = false;
            this.$emit('searchSimList');
          }else{
            this.$message({
              type:'warning',
              message:data.msg
            });
          }
        }).catch(()=>{

        })
      }catch({msg}){
        this.$message({
          type:'warning',
          message:msg
        });
      }
      this.$API.getUserCornInfo()
    },
    //获取消耗币数与区分新旧卡
    async changeRenew() {
      if(this.renewParams.sim){
        let params = {
          simSegment:this.renewParams.type == 3?this.renewParams.sim.replace(/(\s|[\r\n]|','|'，')/g,'|'):this.renewParams.sim,
          type:this.renewParams.type
        }
        const { data } = await this.$API.checkFlowPackage(params); 
        console.log(data);
        if(data.code != 0){
          this.$confirm(data.msg, '提示', {
            confirmButtonText: '关闭',
            cancelButtonText: '取消',
            type: 'warning',
            showCancelButton:false,
            center: true
          }).then(() => {
            this.visible = false;
          }).catch(() => {
            this.visible = false;
          });
          return false;
        }
        this.renewParams.newCorn = 0;
        this.renewParams.oldCorn = 0;
        this.renewParams.connectCorn = 0;
        this.renewParams.simType = '';
        this.renewParams.oldSimType = '';
        this.renewParams.connectSimType = '';
        this.renewParams.new = data.data.new.map(item=>{
          return {
            simCard:item.simCard,
            packageType: '',
            cardSupplier:this.useCardSupplier(item.cardSupplier)
          }
        });
        this.renewParams.old = data.data.old.map(item=>{
          return {
            simCard:item.simCard,
            packageType: '',
            cardSupplier:this.useCardSupplier(item.cardSupplier)
          }
        });
        if(data.data.unicom){
          this.renewParams.connect = data.data.unicom.map(item=>{
            return {
              simCard:item.simCard,
              packageType: '',
              cardSupplier:this.useCardSupplier(item.cardSupplier)
            }
          });
        }
        data.data.errorList.length && (//非北京卡或者无续费价格，
          this.outSimShowSimSegment =  '该卡不支持该业务，请核实 ：' + data.data.errorList.join(','),
          this.outSimShow = true,
          this.visible = false
        ) 
      }
    },
    //统计消费币
    handleConsume(val,type){
      let name = type === 1 ?'simType':type === 2 ? 'oldSimType' : 'connectSimType';
      let simName = type === 1?'new' : type === 2 ?'old' : 'connect';
      this.renewParams[simName] = this.renewParams[simName].map(item=>{
        return {
          ...item,
          packageType:this[name].filter(item=>item.value == val)[0].id
        }
      });
      this.renewParams[`${simName}Corn`] = this[name].filter(item=>item.value == val)[0].price * this.renewParams[simName].length;
    },
    //关闭弹框
    handleClose(){
      this.renewParams = {
        activeType:0,
        simType:'',
        oldSimType:'',
        connectSimType:'',
        remark:'',
        type:0,
        sim:'',
        checked:false,
        new:[],
        old:[],
        connect:[],
        newCorn:0,
        oldCorn:0,
        connectCorn:0,
        secondPassword:'',
        excelFile:null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../public/css/mixin.scss";
.price_box {
  .download{
    color:#409EFF;
    cursor: pointer;
    text-align: right;
    margin: 10px 0;
    display: inline-block;
  }
  /deep/.el-input__icon{
    line-height: 34px;
  }
  /deep/.el-dialog__body{
    padding: 10px;
  }
  .list {
    margin: 10px 0;
    overflow: hidden;
    >div{
      width:calc(33.333% - 1px);
      float: left;
      >span{
        color:#FFF;
        font-size: 14px;
        display: block;
        background: #4B88F6;
        padding: 10px;
      }
    }
    &__ul{
      border:1px solid #eee;
      box-sizing: border-box;
      height: 360px;
      overflow-y: auto;
      @include scrollBar;
      >li{
        padding: 0 10px;
        list-style: none;
        border-bottom: 1px solid #eee;
        margin: 0;
        line-height: 30px;
        color:#666;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .w__100{
    >div{
      width:100% !important;
      float: left;
      >span{
        color:#FFF;
        font-size: 14px;
        display: block;
        background: #4B88F6;
        padding: 10px;
      }
    }
  }
  // margin:
  .box_p{
    margin: 10px 0 0 0;
    span{
      color:#eb5b5b;
    }
  }
  .price_Num {
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    // font-weight: bold;
    display: inline-block;
    margin-left: 10px;
    color: #d61c1c;
  }
  .price_p{
    color:#999;
    margin: 20px 0;
  }
  .price_row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    &_span{
      color:#d61c1c;
      font-size:12px;
      display: inline-block;
      margin-left: 10px;
    }
    .price_code {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // text-align: center;
      align-items: center;
      &:nth-child(2) {
        margin-left: 50px;
      }
      span {
        font-size: 12px;
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      img {
        width: 148px;
        height: 148px;
      }
    }
  }
  .price_label {
    display: inline-block;
    width: 100px;
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  & /deep/ .input__suffix {
    top: 5px;
  }
  & /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  /deep/.el-dialog__footer{
    text-align: right !important;
  }
}
</style>